import React from "react";
import { TitleCompProps } from "./types";

// Title Component
export function TitleComp({ minSlots, isVisible }: TitleCompProps): React.ReactElement | null {
	if (!isVisible) return null;

	return <p className="text-red-500 text-xs leading-5">{`Minimum ${minSlots} slots are required.`}</p>;
}
